"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppScreenLayout = exports.AppScreenLayoutDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var page_header_bar_1 = require("./page-header-bar");
var window_size_1 = require("@react-hook/window-size");
var use_dimensions_1 = require("../../hooks/use-dimensions");
var use_sidebar_layout_1 = require("../../hooks/use-sidebar-layout");
var app_layout_context_1 = require("../context/app-layout-context");
var use_sidebar_1 = require("../../hooks/use-sidebar");
exports.AppScreenLayoutDefaultProps = {
  overflow: 'auto',
  showHeader: true,
  footerHeight: 0,
  availableHeightDelta: 0
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    /* flex-grow: 1; */\n    // height: calc(100vh - env(safe-area-inset-bottom));\n    overflow: hidden;\n    margin-left: 0;\n    transition: margin 0.3s;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    /* flex-grow: 1; */\n    // height: calc(100vh - env(safe-area-inset-bottom));\n    overflow: hidden;\n    margin-left: 0;\n    transition: margin 0.3s;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isSidebarShown = _a.isSidebarShown;
    return isSidebarShown && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin-left: 280px;\n    "], ["\n      margin-left: 280px;\n    "])));
  }),
  desktopLarge: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isSidebarShown = _a.isSidebarShown;
    return isSidebarShown && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      margin-left: 320px;\n    "], ["\n      margin-left: 320px;\n    "])));
  })
});
var HeaderContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    flex-shrink: 0;\n    flex-grow: 0;\n  "], ["\n    flex-shrink: 0;\n    flex-grow: 0;\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    // flex-grow: 1;\n    background: ", ";\n    overflow-y: auto;\n    margin-left: 0;\n    overflow-x: hidden;\n\n    ", "\n  "], ["\n    // flex-grow: 1;\n    background: ", ";\n    overflow-y: auto;\n    margin-left: 0;\n    overflow-x: hidden;\n\n    ", "\n  "])), theme_1.theme.COLOR('light'), function (_a) {
    var _height = _a._height,
      _width = _a._width,
      overflow = _a.overflow;
    return (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      height: ", "px;\n      width: ", "px;\n      overflow-y: ", ";\n    "], ["\n      height: ", "px;\n      width: ", "px;\n      overflow-y: ", ";\n    "])), _height, _width, overflow);
  })
});
var FooterStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    flex-shrink: 0;\n  "], ["\n    flex-shrink: 0;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.main(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  HeaderContainer: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), HeaderContainerStyles),
  Header: (0, styled_components_1.default)(page_header_bar_1.PageHeaderBar)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Body: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Footer: styled_components_1.default.footer(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles)
};
exports.AppScreenLayout = react_1.default.forwardRef(function (props, ref) {
  var className = props.className,
    header = props.header,
    footer = props.footer,
    children = props.children,
    overflow = props.overflow,
    showHeader = props.showHeader,
    availableHeightDelta = props.availableHeightDelta;
  var _a = __read((0, use_dimensions_1.useDimensions)(), 2),
    headerRef = _a[0],
    headerInfo = _a[1];
  var _b = __read((0, use_dimensions_1.useDimensions)(), 2),
    footerRef = _b[0],
    footerInfo = _b[1];
  var windowHeight = (0, window_size_1.useWindowHeight)();
  var windowWidth = (0, window_size_1.useWindowWidth)();
  var sidebar = (0, use_sidebar_1.useSidebar)();
  var sidebarState = (sidebar === null || sidebar === void 0 ? void 0 : sidebar.state) || {
    isShown: false
  };
  var sidebarInfo = (0, use_sidebar_layout_1.useSidebarLayout)();
  var sidebarWidth = sidebarInfo.width || 0;
  var headerHeight = headerInfo.height || 0;
  var footerHeight = props.footerHeight || footerInfo.height || 0;
  var getAvailableWidth = function () {
    return windowWidth - (sidebarState.isShown && windowWidth >= 1024 ? sidebarWidth : 0);
  };
  var _c = __read((0, react_1.useState)(getAvailableWidth()), 2),
    availableWidth = _c[0],
    setAvailableWidth = _c[1];
  (0, react_1.useEffect)(function () {
    setAvailableWidth(getAvailableWidth());
  }, [sidebarState.isShown, windowWidth, sidebarWidth]);
  var bodyHeight = windowHeight - headerHeight - footerHeight;
  var containerRef = (0, react_1.useRef)();
  // console.log(windowHeight, bodyHeight, headerHeight, footerHeight, availableHeightDelta);
  var appLayoutInfo = {
    height: windowHeight,
    width: windowWidth,
    headerHeight: headerHeight,
    footerHeight: footerHeight,
    availableHeight: windowHeight - headerHeight - footerHeight - availableHeightDelta,
    availableWidth: availableWidth
  };
  return react_1.default.createElement(app_layout_context_1.AppLayoutProvider, {
    value: appLayoutInfo
  }, react_1.default.createElement(My.Container, {
    isSidebarShown: sidebarState.isShown,
    className: className
  }, showHeader && react_1.default.createElement(My.HeaderContainer, {
    ref: headerRef
  }, react_1.default.createElement(My.Header, null, header)), react_1.default.createElement(My.Body, {
    overflow: overflow,
    _width: availableWidth,
    _height: bodyHeight
  }, children), footer && react_1.default.createElement(My.Footer, {
    ref: footerRef
  }, footer)));
});
exports.AppScreenLayout.defaultProps = exports.AppScreenLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;